import React, { useMemo } from 'react';
import MarkdownBlock from '../markdown/MarkdownBlock';
import { prepareBlocks } from '../markdown/splitBlocks';

function TableSkeleton() {
  return (
    <div className="cv-table-skeleton" aria-hidden="true">
      {[0, 1, 2].map((r) => (
        <div key={r} className="cv-table-skeleton__row">
          {[0, 1, 2, 3].map((c) => <span key={c} />)}
        </div>
      ))}
    </div>
  );
}

/**
 * The answer body, rendered as markdown at every stage of the stream. While streaming the container keeps
 * the `.streaming-text` class (the Playwright batch script reads it).
 */
export default function MarkdownAnswer({ text, streaming, sourceById }) {
  const blocks = useMemo(() => prepareBlocks(text, { streaming }), [text, streaming]);
  return (
    <div className={`cv-md${streaming ? ' streaming-text' : ''}`}>
      {blocks.map((b) => (b.skeleton === 'table'
        ? <TableSkeleton key={b.key} />
        : <MarkdownBlock key={b.key} md={b.md} sourceById={sourceById} />))}
    </div>
  );
}
